import { lazy, Suspense } from "react";
import { parseRoute, usePathname } from "./lib/router.ts";
import { Landing } from "./screens/Landing.tsx";
import { Play } from "./screens/Play.tsx";
import { BigScreen, PairRedirect } from "./screens/screen/BigScreen.tsx";

// The dev harness is only ever loaded on /dev/table.
const DevTable = lazy(() => import("./dev/DevTable.tsx"));
// The rules handout carries the design doc's text: loaded only on /rules.
const Rules = lazy(() => import("./screens/Rules.tsx"));
// The intro video (§17.4): loaded only on /intro.
const Intro = lazy(() => import("./screens/intro/Intro.tsx"));

export function App() {
  const route = parseRoute(usePathname());
  switch (route.name) {
    case "landing":
      return <Landing key={route.code ?? ""} code={route.code} />;
    case "play":
      return <Play key={route.code} code={route.code} />;
    case "screen":
      return <BigScreen />;
    case "pair":
      return <PairRedirect code={route.code} />;
    case "rules":
      return (
        <Suspense fallback={<p className="center muted">Loading the rules…</p>}>
          <Rules />
        </Suspense>
      );
    case "intro":
      return (
        <Suspense fallback={<p className="center muted">Loading the intro…</p>}>
          <Intro />
        </Suspense>
      );
    case "devTable":
      return (
        <Suspense fallback={<p className="center muted">Loading the dev table…</p>}>
          <DevTable />
        </Suspense>
      );
    default:
      return (
        <div className="app">
          <main className="main no-tabs stack center">
            <h1>Not found</h1>
            <a href="/">Back to the start</a>
          </main>
        </div>
      );
  }
}
